module.exports = __webpack_public_path__ + "img/public/SiteIcons/photoUpload.svg?4b1a76bc";